module.exports = __webpack_public_path__ + "c5f09d657b4d333624990106a6116339.png";